// client/src/components/UnderConstruction.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './UnderConstruction.css'; // Separate CSS

function UnderConstruction() {
  const { t } = useTranslation();

  return (
    <div className="under-construction">
      <img src="/images/under-construction.jpeg" alt={t('UnderConstruction.underConstructionAltText')} className="under-construction__image" />
      <h2 className='under-construction__title'>{t('UnderConstruction.pageInConstruction')}</h2>
      <p className='under-construction__message'>{t('UnderConstruction.pageInConstructionMessage')}</p>
    </div>
  );
}

export default UnderConstruction;